import { render, staticRenderFns } from "./UserDocs.vue?vue&type=template&id=6546cdf2&scoped=true&"
import script from "./UserDocs.vue?vue&type=script&lang=js&"
export * from "./UserDocs.vue?vue&type=script&lang=js&"
import style0 from "./UserDocs.vue?vue&type=style&index=0&id=6546cdf2&lang=scss&scoped=true&"
import style1 from "./UserDocs.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6546cdf2",
  null
  
)

export default component.exports